<template>
	<div class="bb-panel-wrapper">
		<PricingScenarios v-show="activeForm === 1" />
		<PricingProducts v-if="activeForm === 2" />
		<PricingError v-if="activeForm === 3" />
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PricingScenarios from '@/views/brand-builder/brand-builder-nested-routes/BbPricingScenarios.vue';
import PricingProducts from '@/views/brand-builder/brand-builder-nested-routes/BbPricingProducts.vue';
import PricingError from '@/views/brand-builder/brand-builder-nested-routes/BbPricingError.vue';

export default {
	name: 'BbPricing',

	components: {
		PricingScenarios,
		PricingProducts,
		PricingError,
	},

	methods: {
		...mapActions(['updatePricingFields']),
	},

	computed: {
		...mapState({
			activeForm: (state) => state.lendwizePricingScenario.activeForm,
		}),
	},

	mounted() {
		this.updatePricingFields({
			fieldName: 'activeForm',
			value: 1,
		});
	},
};
</script>
